<template>
  <div class="app-container">
    <div class="catch-box">
      <div class="intro-section">
        <div class="intro-text">
          <div class="speech-bubble">
            そんなお悩みを抱えている方は、<span class="bold-red">給湯器の専門業者に依頼</span>するのがおすすめです！
          </div>
        </div>
        <div class="intro-title-img">
          <img src="../../assets/vendor.png" alt="">
        </div>
      </div>
    </div>
    <RecommendationReasons />
    <ComparisonTable />
  </div>
</template>

<script setup>
import ComparisonTable from './ComparisonTable.vue'
// import RecommendationReasons from './RecommendationReasons.vue'
</script>

<style scoped>
.app-container {
  background: #f0f0fb;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0;
}

.catch-box {
  text-align: center;
  /* margin: 15px 0 25px; */
  width: 100%;
  max-width: 900px;
  padding-top: 20px;
}

.intro-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.intro-section img {
  width: 100%;
}

.speech-bubble {
  position: relative;
  background: #fff;
  font-weight: bold;
  font-size: 1rem;
  padding: 15px 20px;
  border-radius: 10px;
  line-height: 1.5;
  max-width: 300px;
  border: 2px solid #2c387e;
  text-align: left;
}

.speech-bubble::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -21px;
  transform: translateY(-50%);
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent transparent black;
}

.intro-title-img {
  width: 30%;
}

.point-label {
  display: inline-block;
  background: #e3f2fd;       /* 淡いブルー背景 */
  color: #1976d2;           /* ブルー文字 */
  font-size: 16px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 4px;       /* 少し角丸 */
  line-height: 1.4;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* 影をつけてカード感 */
  letter-spacing: 0.5px;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
  .point-label {
    font-size: 14px;
    padding: 5px 10px;
  }

  .app-container {
    padding: 0;
  }
  
  .speech-bubble {
    font-size: 1rem;
    padding: 10px;
  }

  .intro-section {
    margin-bottom: 16px;
    margin-left: 10px;
  }

  .intro-title-img img {
    width: 100%;
  }
}
</style>
